export default __webpack_public_path__ + "static/media/list-school-management.13fb7a0e.svg";